import { Factory } from './factory';
import { Audio } from '../audio';
import { Position } from '../position';
import { Injectable } from '@angular/core';
import { ApplicationStateService } from '../../services/application-state.service';

@Injectable({
    providedIn: 'root'
})
export class AudioFactory implements Factory<Audio> {

    constructor(private applicationStateService: ApplicationStateService) {
    }

    buildFromFactory(): Audio {
        return undefined;
    }

    buildFromObject(jsonObject: any): Audio {
        const audio = new Audio();
        audio.id = jsonObject.id;
        audio.pageId = jsonObject.pageId;
        const position = new Position();
        position.x = +jsonObject.position.x;
        position.y = +jsonObject.position.y;
        position.w = +jsonObject.position.w;
        position.h = +jsonObject.position.h;
        audio.position = position;
        audio.audioFile = jsonObject.audioFile;
        audio.url = jsonObject.url;
        audio.bypassCheck = this.applicationStateService.bookConfig.bookPermissions.bookAudio.view;

        return audio;
    }
}
